export default __webpack_public_path__ + "static/media/istockphoto-511784636-170667a.8b757f7e.jpg";